/*
  Sengehuset cart drawer helpers.
  Uses delegated listeners because Dawn re-renders the drawer HTML after every cart change.
  - [data-sh-upsell-add]: adds one unit of a variant, then lets Dawn's cart-drawer re-render itself.
  - [data-sh-cart-close]: closes the drawer ("Fortsett å handle").
*/
(function () {
  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function showError(button, message) {
    var box = button.closest('.sh-upsell');
    var el = box && box.querySelector('.sh-upsell__error');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  document.addEventListener('click', function (event) {
    var close = event.target.closest('[data-sh-cart-close]');
    if (close) {
      event.preventDefault();
      var d = drawer();
      if (d) d.close();
      return;
    }

    var button = event.target.closest('[data-sh-upsell-add]');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;

    var d = drawer();
    var sections = d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : [];

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.shUpsellAdd), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          throw new Error(result.data.description || result.data.message || 'Kunne ikke legge varen i handlekurven.');
        }
        if (d && result.data.sections) {
          d.renderContents(result.data);
        } else {
          window.location.href = window.routes ? window.routes.cart_url : '/cart';
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sh-cart-upsell', cartData: result.data });
        }
      })
      .catch(function (error) {
        button.removeAttribute('aria-disabled');
        button.classList.remove('is-loading');
        showError(button, error.message || 'Noe gikk galt. Prøv igjen, eller ring oss.');
      });
  });
})();
